import { render, staticRenderFns } from "./HeroUpgradeTask.vue?vue&type=template&id=6a38bb13&scoped=true"
import script from "./HeroUpgradeTask.vue?vue&type=script&lang=js"
export * from "./HeroUpgradeTask.vue?vue&type=script&lang=js"
import style0 from "./HeroUpgradeTask.vue?vue&type=style&index=0&id=6a38bb13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a38bb13",
  null
  
)

export default component.exports